import pushEvent, { EVENT_444_BANNER_CLICK } from 'pushEvent';

import { THREE_FOURS_SHOW_MODAL, THREE_FOURS_HIDE_MODAL } from './constants';

export const showThreeFoursModal = () => (dispatch) => {
  pushEvent(EVENT_444_BANNER_CLICK);
  dispatch({ type: THREE_FOURS_SHOW_MODAL });
};

export const hideThreeFoursModal = () => ({
  type: THREE_FOURS_HIDE_MODAL,
});
